/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const { wrapRootElement } = require('./src/wrap-root-element')

exports.wrapRootElement = wrapRootElement

// Force service worker updates to prevent blank pages on first load
exports.onServiceWorkerUpdateReady = () => {
  // Force the new service worker to take control so users don't see a blank shell
  window.location.reload()
}
